const { isArray } = require('../../utils')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} field
 * @param {*} value
 * @param {*} validationValue
 * @returns {boolean}
 */
function hasDebts ({ field, value, validationValue }) {
  if (!value) return true
  return isArray(validationValue) && validationValue?.includes(field)
}

module.exports = { hasDebts }
